import { render } from "./CheckUser.vue?vue&type=template&id=d6c82c48"
import script from "./CheckUser.vue?vue&type=script&lang=js"
export * from "./CheckUser.vue?vue&type=script&lang=js"
script.render = render

export default script